import { Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';

import { ImageCroppedEvent } from 'ngx-image-cropper';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Subscription, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';
import { CommonService, ToastService } from '../../../core/services';
import { DOCUMENT } from '@angular/common';

@Component({
    selector: 'gs-image-crop',
    templateUrl: './image-crop.component.html',
    standalone: false
})
export class ImageCropComponent implements OnInit, OnDestroy {
  @Input() type: string = '';
  @Input() originalImage: string = '';
  @Input() editedImage: string = '';
  @Output() fileName: EventEmitter<string> = new EventEmitter<string>();
  @ViewChild('imageUpload') imageUpload: any;

  imageChangedEvent: any = '';
  isImageSelected = false;

  private croppedImage: any = '';
  private subscriptions: Subscription[] = [];

  get canDelete(): boolean {
    return this.editedImage != this.originalImage;
  }

  constructor(
    private commonService: CommonService,
    private ngxUiLoaderService: NgxUiLoaderService,
    private toastService: ToastService,
    @Inject(DOCUMENT) private document: Document
  ) {
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  imageCropped(image: ImageCroppedEvent) {
    this.croppedImage = image.blob;
  }

  onUploadClick() {
    const fd = new FormData(this.document.forms[0]);
    fd.append('file', this.croppedImage);

    this.ngxUiLoaderService.start();
    this.subscriptions.push(
      this.commonService.uploadImage(fd, this.type)
        .pipe(
          catchError(e => {
            this.toastService.show('Eroare', e.error?.detail || e.error?.title || 'A aparut o problema neasteptata. Echipa noastra lucreaza pentru a o remedia.', 'error');
            return throwError(e);
          }),
          finalize(() => {
            this.ngxUiLoaderService.stop();
          })
        )
        .subscribe(response => {
          this.fileName.emit(response.fileName);
          this.isImageSelected = false;
          this.editedImage = environment.contentUrl + (this.type == 'user' ? '/user-images/' : '/event-images/') + response.fileName;
          // this.fileReset();
        })
    );
  }

  onCancelClick() {
    this.isImageSelected = false;
    // this.fileReset();
  }

  onDeleteClick() {
    // this.fileReset();
    this.isImageSelected = false;
    this.editedImage = this.originalImage;
    this.fileName.emit('');
  }

  imageSelected(e: any) {
    this.imageChangedEvent = e;
    this.isImageSelected = true;
  }

  // private fileReset() {
  //    this.imageUpload.nativeElement.value = '';
  // }
}

